import { Button, Modal, Typography, LinkText } from '../ecosystem';

const DashboardPrivacyNotifier = ({ isOpen, okBtnOnclick, href }) => {
    return (
        <Modal
            isOpen={isOpen}
            backdrop="static"
            icon="information"
            modalHeader={"We’ve updated our digital privacy policy"}
            modalBody={<>
                Please take a moment to review our{' '}
                <LinkText typographyType="body-03" to="/privacy">digital privacy policy</LinkText>.
            </>}
            modalFooterButtons={[{
                label: "Okay, got it!",
                onClick: okBtnOnclick
            }]}
        />
    )
}

export default DashboardPrivacyNotifier